import { NotificationVariation } from '@salecycle/ui-component-library';
import { Types } from 'services/genericAPIGatewayService';
import { Action } from 'store';
import { ActionTypes } from './actions';
import i18n from 'i18next';

export type NotificationType = 'success' | 'warning' | 'danger' | 'info' | null;

export interface NotificationBarState {
  visible: boolean;
  variation: NotificationVariation;
  detail?: string;
}

export const InitialState: NotificationBarState = {
  visible: false,
  variation: null,
  detail: '',
};

function reducer(state: NotificationBarState = InitialState, action: Action): NotificationBarState {
  switch (action.type) {
    case Types.CREATE_COMPLETED:
    case Types.PATCH_COMPLETED:
    case Types.UPDATE_COMPLETED:
      return {
        ...state,
        visible: true,
        variation: 'normal',
        detail: i18n.t('common:notificationBar.actions.save.success'),
      };

    case Types.CREATE_FAILED:
    case Types.PATCH_FAILED:
    case Types.UPDATE_FAILED:
      return {
        ...state,
        visible: true,
        variation: 'error',
        detail: i18n.t('common:notificationBar.actions.save.failed', { message: action.payload.error }),
      };

    case Types.DELETE_COMPLETED:
      return {
        ...state,
        visible: true,
        variation: 'normal',
        detail: i18n.t('common:notificationBar.actions.delete.success'),
      };

    case Types.DELETE_FAILED:
      return {
        ...state,
        visible: true,
        variation: 'error',
        detail: i18n.t('common:notificationBar.actions.delete.failed', { message: action.payload.error }),
      };

    case ActionTypes.NOTIFICATION_CLOSED:
      return {
        ...state,
        visible: false,
      };
    // If we're using this please be mindful of passing translated content in 'action.detail'
    case ActionTypes.CUSTOM_NOTIFICATION:
      return {
        ...state,
        visible: true,
        variation: action.variation,
        detail: action.detail,
      };
    default:
      return state;
  }
}

export default reducer;
